// extracted by mini-css-extract-plugin
export default {"checkoutDetailsContainer":"_91deb235","isMobile":"_3f78e142","label":"_e73408be","content":"_e7ab19d1","actions":"_533b4c35","disabledActions":"_c1d17d05"};